module.exports = __webpack_public_path__ + "static/media/display.b4ad502a.png";